import DisplayFull from "./views/DisplayFull";

function App() {
  return (
    <div id="app">
      <DisplayFull />
    </div>
  );
}

export default App;
